import {
  CsvFieldByHeader,
  downloadCsv,
  recordsFromCsv,
} from "../../components/massFlow/csv";
import { AsnPayload, emptyAsn } from "../types";

export const CSV_HEADERS = ["Nome", "ASN"];

const CSV_EXAMPLES = [
  ["ASN exemplo 01", "65001"],
  ["ASN exemplo 02", "65002"],
];

const FIELD_BY_HEADER: CsvFieldByHeader = {
  nome: "nome_asn",
  name: "nome_asn",
  nomeasn: "nome_asn",
  nomedoasn: "nome_asn",
  asname: "nome_asn",
  asn: "asn",
  numeroasn: "asn",
  numerodoasn: "asn",
  asnum: "asn",
  as: "asn",
};

export function asnsFromCsv(text: string): AsnPayload[] {
  return recordsFromCsv(text, {
    fieldByHeader: FIELD_BY_HEADER,
    emptyValues: emptyAsn,
    expectedHeaders: CSV_HEADERS,
  });
}

export function downloadCsvTemplate() {
  downloadCsv("MW Soluções - Template ASNs.csv", [
    CSV_HEADERS,
    ...CSV_EXAMPLES,
  ]);
}
